
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { BaseCouponItem } from '@xt/client/types/coupon'
import { formatCouponInfo, FormatCouponInfo, EnumCouponTimeRule } from '@xt/client/utils/coupon/index'
import { EnumCouponType, EnumPreferentialType } from '@xt/client/enums'
import CouponBtnComp from '@xt/www/components/coupon/CouponBtn.vue'

@Observer
@Component({
  components: {
    CouponBtnComp
  }
})
export default class GiftCoupon extends Vue {
  @Prop({ required: true }) data: BaseCouponItem
  @Prop({ required: true }) success: boolean
  @Prop() isLast: boolean
  formatCouponInfo: FormatCouponInfo

  get EnumCouponTimeRule() {
    return EnumCouponTimeRule
  }

  get couponType(): 'FullReduction' | 'Discount' | 'Exchange' | 'Companion' {
    if (this.data.preferentialType === EnumPreferentialType.StudyBuff && this.data.couponType === EnumCouponType.Companion) {
      return 'Companion'
    }

    switch (this.data.preferentialType) {
      case EnumPreferentialType.FullReduction:
        return 'FullReduction'
      case EnumPreferentialType.Discount:
        return 'Discount'
      case EnumPreferentialType.Exchange:
        return 'Exchange'
      default:
        throw new Error()
    }
  }

  get couponStatus() {
    if (this.success) return { text: '', style: '' }

    return this.data.stockQty === 0 ? { text: '已发完', style: 'black' } : { text: '已经领取过啦', style: 'red' }
  }

  handleClickUseInfo() {
    // @ts-ignore
    this.$refs['coupon-btn-comp']?.clickUseDescHandler(this.success ? EnumCouponTimeRule.PositionRule3 : EnumCouponTimeRule.PositionRule1)
  }

  @Emit('to-use')
  handleToUse() {}

  @Emit('receive')
  handleReceive() {}

  @Emit('exchange')
  handleExchange() {}

  created() {
    this.formatCouponInfo = formatCouponInfo(this.data, this.success ? EnumCouponTimeRule.PositionRule3 : EnumCouponTimeRule.PositionRule1)
  }
}
